import { render, staticRenderFns } from "./RotatePopup.vue?vue&type=template&id=08c2f22c&scoped=true&"
import script from "./RotatePopup.vue?vue&type=script&lang=js&"
export * from "./RotatePopup.vue?vue&type=script&lang=js&"
import style0 from "./RotatePopup.vue?vue&type=style&index=0&id=08c2f22c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2f22c",
  null
  
)

component.options.__file = "RotatePopup.vue"
export default component.exports